import { configureStore } from '@reduxjs/toolkit';
import accordionReducer from './accordionSlice';
import alertReducer from './alertSlice';
import authReducer from './authSlice';
import dashboardReducer from './dashboardSlice';
import toastReducer from './toastSlice';

const store = configureStore({
  reducer: {
    accordion: accordionReducer,
    alert: alertReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    toast: toastReducer
  }
});

export default store;